export const REQUEST_LANG = "REQUEST_LANG";
export const RECEIVE_LANG_DATA = "RECEIVE_LANG_DATA ";
export const CLEAR_LANG_DATA = "CLEAR_LANG_DATA";
